import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Table, Spinner, Form, Button } from 'react-bootstrap';

import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import * as Icon from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { toast } from 'react-toastify';


const ZoTotalCalling = () => {
    const userState = useSelector(state => state.loginData.userData);
    const financialYear = useSelector(state => state.activeData.activeMenu.activeTab);
    const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);
    const UserOptions = {
        page: {
            margin: 10,
        },
        filename: 'User Wise Calling.pdf'
    };

    const userWiseTarget = useRef();

    const [userLoader, setUserLoader] = useState(false);
    const [userWiseCalling, setUserWiseCalling] = useState('');
    const [date, setDate] = useState('');

    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    useEffect(() => {
        getUserWiseTotalCalling();
    }, [startDate, endDate])

    const getUserWiseTotalCalling = async () => {
        setUserLoader(true);
        await fetch(process.env.REACT_APP_BASE_URL + '/user/getCombinedCallingUsers', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                zonename: userState?.zonename,
                // callingDate: date,
                financialYear: "",
                fromDate: startDate,
                toDate: endDate
            })
        }).then((res) => res.json()).then((response) => {
            setUserWiseCalling(response?.data);
            setUserLoader(false);
        }).catch((Err) => {
            console.log("Err while getting user wise calling", Err);
            setUserLoader(false);
        })
    }

    const exportUserWiseCallingToExcel = async () => {
        try {
            // 1️⃣ Fetch latest data using your API
            const response = await fetch(process.env.REACT_APP_BASE_URL + '/user/getCombinedCallingUsers', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    zonename: userState?.zonename,
                    financialYear: "",
                    fromDate: startDate,
                    toDate: endDate
                })
            });

            const result = await response.json();
            const data = result?.data;

            if (!data || !Array.isArray(data)) {
                toast.error("No data found to export.");
                return;
            }

            // 2️⃣ Prepare Excel headers
            const wsData = [
                ['Sr. No', 'Name', 'Mobile', 'Zone', 'Gatname', 'Role','Calling Count','Talk Duration' ] // Adjust columns as needed
            ];

            // 3️⃣ Push data rows
            data.forEach((row, index) => {
                const gatnameStr = (row.gatname || []).join(', ');
                wsData.push([
                    index + 1,
                    row.name || '',
                    row.contactNo || '',
                    row.zonename || '',
                    `'${gatnameStr}`, // 👈 prevents Excel from formatting as date
                    row?.usertype_name ,
                    row?.callingCount,
                    row?.talkDuration

                ]);
            });

            // 4️⃣ Create worksheet & format
            const worksheet = XLSX.utils.aoa_to_sheet(wsData);
            worksheet['!cols'] = [
                { width: 6 },
                { width: 20 },
                { width: 15 },
                { width: 15 },
                { width: 30 },
                { width: 20 },
                { width: 20 },
                { width: 20 }
            ];

            // 5️⃣ Create and download workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'UserWiseCalling');
            XLSX.writeFile(workbook, `UserWiseCalling_${moment().format('YYYY-MM-DD')}.xlsx`);

        } catch (error) {
            console.error("Excel export error:", error);
            toast.error("Failed to export Excel file.");
        }
    };
   


    return (
        <div className='TotalCalling mb-5'>
            <Row className='justify-content-between align-items-center'>
                <Col md={4} className='d-flex mb-3 mb-md-0'>
                    <div className='me-3'>
                        <Form.Label>Search by Start date</Form.Label>
                        <Form.Control type="date" value={startDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => setStartDate(moment(e.target.value).format("YYYY-MM-DD"))} />
                    </div>
                    <div className='me-3'>
                        <Form.Label>Search by End date</Form.Label>
                        <Form.Control type="date" value={endDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => setEndDate(moment(e.target.value).format("YYYY-MM-DD"))} />
                    </div>
                </Col>

                <Col md={4} className='d-flex mb-3 mb-md-0'>
                    {/* {
                        userWiseCalling && userWiseCalling?.length > 0 && */}
                    <Button className='btn-cancel mx-auto' onClick={exportUserWiseCallingToExcel}>
                        <Icon.ArrowDownCircle size={14} className='me-2' />Download UserWise Excel
                    </Button>
                    {/* } */}
                </Col>
            </Row>

            <div className="container tbl-container p-0 mt-4" ref={userWiseTarget}>
                <div className="row tbl-fixed p-0">
                    <Table responsive="lg" hover>
                        <thead>
                            <tr>
                                <th>Sr.</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Zone</th>
                                <th>Gat</th>
                                <th>Role</th>
                                <th>Calling Count</th>
                                <th>Talk Duration</th>
                            </tr>
                        </thead>

                        {userLoader ? (
                            <Spinner variant="primary" className="mt-2" />
                        ) : (
                            <tbody>
                                {userWiseCalling !== null && userWiseCalling !== undefined && userWiseCalling.length > 0
                                    ? userWiseCalling.map((row, index) => {
                                        return (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{row?.name}</td>
                                                <td>{row?.contactNo}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{row?.zonename + '-' + row?.zoneno}</td>
                                                <td style={{ maxWidth: '150px', wordWrap: 'break-word' }}>{row?.gatname.map((row) => row).join(', ')}</td>
                                                <td>{row?.usertype_name}</td>
                                                <td>{row?.callingCount}</td>
                                                <td>{row?.talkDuration}</td>
                                            </tr>
                                        );
                                    })
                                    : "No data found"}
                            </tbody>
                        )}
                    </Table>
                </div>
            </div>
        </div >
    )
}

export default ZoTotalCalling;